export class AverageBallCalculation {
  id: number = null;
  enrollId: number = null;
  count_5: number = null;
  count_4: number = null;
  count_3: number = null;
  average: number = null;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-attestat-average-calculation.ts